import { styled } from '@mui/material';
import Toolbar from '@mui/material/Toolbar';
import React from 'react';
import TheGuarantorsLogo from 'src/assets/images/TheGuarantors_Logo.svg';

const ToolbarStyled = styled(Toolbar)({
  borderRadius: '8px',
  backgroundColor: 'white',
  color: 'white',
  display: 'flex',
  justifyContent: 'center',
  boxShadow: '4px 16px 32px rgba(0, 0, 0, 0.08)',
  marginX: '10px',
  marginTop: '10px',
});

const LearnHeader = () => {
  return (
    <ToolbarStyled>
      <img height="30px" alt="" src={TheGuarantorsLogo} />
    </ToolbarStyled>
  );
};

export default LearnHeader;
